// src/teamData.js
import team1 from '../assets/team1.png';
import team2 from '../assets/team2.png';
import team3 from '../assets/team3.png';
import mystery from '../assets/mystery.png';

export const teamMembers = [
  {
    id: 'eldric-1',
    name: 'Han "Ruby Weapon"',
    portrait: team1,
    health: 100,
    Magic: 99,
    Intelligence: 67,
    Logic: 1,
    bio: `The Wizard walks the path of countless battles, from leading the raid on the Lich King atop Icecrown Citadel to the onchain battle with the jeets, he sits in solitude till the next quest presents itself`,
  },
  {
    id: 'eldric-2',
    name: 'LongC "SojuCat"',
    portrait: team2,
    health: 88,
    strength: 88,
    intelligence: 88,
    charisma: 88,
    bio: `He who hides in the shadows, the nightlord fought countless raids onchain. From solo speedruns of Zakum to the 0 - 500 back to 0 Sol runs in the great Solana rush of 2024, LongC led his former guild in gaming and digital collectables before delving into the new abyss of Adventure Creative.`,
  },
  {
    id: 'eldric-3',
    name: 'Jo "Jet"',
    portrait: team3,
    health: 1,
    strength: 69,
    intelligence: 67,
    charisma: 67,
    bio: `Jet is just the ops guy — the one who keeps everything moving in the background. 
While others take the spotlight, he handles the unglamorous work: timelines, wallets, deployments, and making sure nothing breaks. 
Not here to be a hero — just here to make sure the quest gets finished.`,
  },

  {
    id: 'eldric-3',
    name: "Mystery Onchain Slayer",
    portrait: mystery,
    X: 0,
    Y: 0,
    Z: 0,

    bio: `... a low rumble echoes from somewhere beyond the veil.
... the air grows heavy. the ground answers in silence.
... something stirs — not awake, not asleep. waiting.`,
  },
];
